/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import {enableProdMode} from '@angular/core';
import {platformBrowserDynamic} from '@angular/platform-browser-dynamic';
import {APP_CONFIG} from './app/app.config';

import {AppModule} from './app/app.module';
import {environment} from './environments/environment';

if (environment.production) {
  enableProdMode();
}

fetch("config/config.json")
.then((response) => response.json())
.then((config) =>
  platformBrowserDynamic([
    {
      provide: APP_CONFIG,
      useValue: config,
    },
  ]).bootstrapModule(AppModule),
)
.catch((err) => console.error(err));
